// extracted by mini-css-extract-plugin
export default {"container":"ConfirmNomination_container__dJPse"};